import { match } from 'ts-pattern'
import { z } from 'zod'
import { Spinner } from '../spinner.tsx'
import * as styles from './status-notification.css.ts'

export const StatusNotificationStatusSchema = z.enum(['in-progress', 'available'])
export type StatusNotificationStatus = z.infer<typeof StatusNotificationStatusSchema>

export type StatusNotificationProps = {
  status: StatusNotificationStatus
  text: string
  actionLabel?: string
  onAction?: () => unknown
}

export const StatusNotification: React.FC<StatusNotificationProps> = ({ status, text, actionLabel, onAction }) => {
  return (
    <div className={styles.container}>
      {match(status)
        .with('in-progress', () => <Spinner size="16" variant="updating" label={text} />)
        .with('available', () => <div className={styles.dot} aria-hidden="true" />)
        .exhaustive()}
      <span className={styles.text}>{text}</span>
      {actionLabel && onAction && (
        <button className={styles.actionButton} onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  )
}
